/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  ReassignprojectgroupData: null
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.ReassignProjectGroupsAction.REASSIGN_PROJECT_GROUP:
      return {
        ...state,
    };
    case actions.ReassignProjectGroupsAction.REASSIGN_PROJECT_GROUP_RESPONSE:
          return{
      ...state,
      ReassignprojectgroupData : action.data.StatusCode,
    };

    default:
      return state;
  }
};

export default reducer;
